import { useState, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import {
  useEmails,
  useEmailStats,
} from '../../../hooks/useEmailQueries.ts';
import { EmailsTables } from './components/Tables.tsx';
import { StatisticCard } from './components/StatisticCard.tsx';
import { Controls } from './Controls.tsx';

export function EmailDashboard() {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  const { data: emailsData, isLoading: emailsLoading, error: emailsError } = useEmails(currentPage, pageSize, searchTerm, statusFilter);
  const { data: stats, isLoading: statsLoading } = useEmailStats();

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter]);

  const emails = emailsData?.data || [];

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const isLoading = emailsLoading || statsLoading;

  if (emailsError) return (
    <div className="flex items-center justify-center py-8">
      <AlertCircle className="h-8 w-8 text-red-500 mr-2" />
      <span>Error loading email data</span>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {/* <StatisticCard title="Active Chats" value={stats?.total_pending || 0} />
        <StatisticCard title="Chats" value={stats?.total_awaiting_preview || 0} /> */}
        <StatisticCard title="Sent Today" value={stats?.total_sent_today || 0} />
        <StatisticCard title="Failed" value={stats?.total_failed || 0} />
      </div>

      {/* Controls */}
      <Controls
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />

      <EmailsTables 
        emails={emails}
        pagination={emailsData?.pagination}
        currentPage={currentPage - 1} // Convert to 0-based index
        onPageChange={(page) => handlePageChange(page + 1)} 
        loading={isLoading}
      />


    </div>
  );
} 